import { createFileRoute } from "@tanstack/react-router";

import PrivacyPage from "@/landing/privacy/page";

const SITE_URL = "https://diningmate.com.au";

export const Route = createFileRoute("/privacy")({
    head: () => ({
        meta: [
            { title: "Privacy Policy | DiningMate" },
            {
                name: "description",
                content:
                    "Read the DiningMate Privacy Policy to learn how we collect, use, and protect your personal information.",
            },
            { property: "og:title", content: "Privacy Policy | DiningMate" },
            {
                property: "og:description",
                content:
                    "Read the DiningMate Privacy Policy to learn how we collect, use, and protect your personal information.",
            },
            { property: "og:url", content: `${SITE_URL}/privacy` },
            { name: "robots", content: "noindex" },
        ],
        links: [{ rel: "canonical", href: `${SITE_URL}/privacy` }],
    }),
    component: PrivacyPage,
});
